function injectStyles() {
    if (document.getElementById('modal-styles'))
        return;
    const style = document.createElement('style');
    style.id = 'modal-styles';
    style.textContent = `
    .modal-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.75);
      backdrop-filter: blur(4px);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      z-index: var(--z-modal, 100);
      animation: overlay-in 200ms ease forwards;
    }

    .modal {
      background: var(--color-surface, #0d0d0d);
      border: 1px solid var(--color-border, #2a2a2a);
      border-radius: var(--radius-xl, 24px);
      padding: 28px;
      width: 100%;
      max-width: 440px;
      box-shadow: var(--shadow-lg, 0 8px 32px rgba(0,0,0,0.6));
      animation: modal-in 250ms cubic-bezier(0.16,1,0.3,1) forwards;
    }

    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
    }

    .modal-title {
      font-size: 1.125rem;
      font-weight: 700;
      color: var(--color-text, #f0f0f0);
    }

    .modal-close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: var(--radius-sm, 8px);
      background: var(--color-surface-2, #161616);
      border: 1px solid var(--color-border, #2a2a2a);
      color: var(--color-text-muted, #888888);
      cursor: pointer;
      transition: all 150ms ease;
    }

    .modal-close:hover {
      background: var(--color-surface-3, #1e1e1e);
      color: var(--color-text, #f0f0f0);
    }

    @keyframes overlay-in {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes modal-in {
      from { opacity: 0; transform: scale(0.94) translateY(8px); }
      to { opacity: 1; transform: scale(1) translateY(0); }
    }
  `;
    document.head.appendChild(style);
}
export function createModal({ title, content, onClose }) {
    injectStyles();
    let overlay = null;
    const close = () => {
        if (!overlay)
            return;
        overlay.style.opacity = '0';
        setTimeout(() => {
            overlay?.remove();
            overlay = null;
            onClose?.();
        }, 200);
    };
    const open = () => {
        overlay = document.createElement('div');
        overlay.className = 'modal-overlay';
        const modal = document.createElement('div');
        modal.className = 'modal';
        const header = document.createElement('div');
        header.className = 'modal-header';
        const titleEl = document.createElement('h2');
        titleEl.className = 'modal-title';
        titleEl.textContent = title;
        const closeBtn = document.createElement('button');
        closeBtn.className = 'modal-close';
        closeBtn.setAttribute('aria-label', 'Close modal');
        closeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
        closeBtn.addEventListener('click', close);
        header.appendChild(titleEl);
        header.appendChild(closeBtn);
        modal.appendChild(header);
        modal.appendChild(content);
        overlay.appendChild(modal);
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay)
                close();
        });
        document.body.appendChild(overlay);
    };
    return { open, close };
}
